import { render, staticRenderFns } from "./KYProtocol.vue?vue&type=template&id=55961237&scoped=true"
import script from "./KYProtocol.vue?vue&type=script&lang=js"
export * from "./KYProtocol.vue?vue&type=script&lang=js"
import style0 from "./KYProtocol.vue?vue&type=style&index=0&id=55961237&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55961237",
  null
  
)

export default component.exports